
const POPUP_CHOICE = 'quickRegistrationChoice';
const POPUP_FORM = 'quickRegistrationForm';
const POPUP_CONFIRM_PHONE = 'quickRegistrationFormConfirmPhone';
const POPUP_AUTH = 'quickAuth';
const POPUP_FORGOT_PHONE = 'quickRegForgotPasswordPhone';
const POPUP_FORGOT_EMAIL = 'quickRegForgotPasswordEmail';
const $choicePopup = $(`.js-common-popup[data-name="${POPUP_CHOICE}"]`);
const $formPopup = $(`.js-common-popup[data-name="${POPUP_FORM}"]`);
const $confirmPhonePopup = $(`.js-common-popup[data-name="${POPUP_CONFIRM_PHONE}"]`);
const $authPopup = $(`.js-common-popup[data-name="${POPUP_AUTH}"]`);
const $forgotPhonePopup = $(`.js-common-popup[data-name="${POPUP_FORGOT_PHONE}"]`);
const $forgotEmailPopup = $(`.js-common-popup[data-name="${POPUP_FORGOT_EMAIL}"]`);
const $smsRequest = $('.js-form-quick-reg-sms-request');
const $smsSend = $('.js-form-quick-reg-sms-send');
const $smsResend = $('.js-form-quick-reg-sms-resend');
const $registrationForm = $('.js-quick-registration-form');
const $quickAuthPhoneForm = $('.js-quick-auth-phone-form');
const $quickAuthEmailForm = $('.js-quick-auth-email-form');
const $quickRegPhone = $('.js-sms-phone-field', $formPopup);
const smsResendDuration = 10;
let smsResendTimer;


if ($choicePopup.length) {
    if ($choicePopup.is('.common-popup--opened')) {
        App.H.addClass('_noscroll');
    } else {
        $choicePopup
            .find('.common-popup-inner')
            .prepend('<div class="common-popup__close js-common-popup-close" tabindex="0"></div>');

        $('.js-quick-registration-choice-close')
            .addClass('js-common-popup-close')
            .on('click', e => e.preventDefault());
    }

    $(`[data-popup="${POPUP_FORM}"], [data-popup="${POPUP_AUTH}"]`).on('click', () => {
        $choicePopup.trigger('popup:close');
    });
}

$('.reg-btn').each((i, el) => {
    setTimeout(() => {
        $(el).addClass('_active');
    }, 10000);
});

$('.js-common-popup-back', $formPopup).on('click', () => {
    $formPopup.trigger('popup:close');

    requestAnimationFrame(() => {
        $choicePopup.trigger('popup:open', {name: POPUP_CHOICE});
    });
});

$('.js-common-popup-back', $confirmPhonePopup).on('click', () => {
    $confirmPhonePopup.trigger('popup:close');

    requestAnimationFrame(() => {
        $formPopup.trigger('popup:open', {
            name: POPUP_FORM,
            noResetForm: true
        });
    });
});

$('.js-common-popup-close', $authPopup).on('click', () => {
    $authPopup.trigger('popup:close');

    requestAnimationFrame(() => {
        $choicePopup.trigger('popup:open', {
            name: POPUP_CHOICE
        });
    });
});

$('.js-common-popup-back', $forgotPhonePopup).on('click', (e) => {
    $forgotPhonePopup.trigger('popup:close');

    requestAnimationFrame(() => {
        $authPopup.trigger('popup:open', {
            name: POPUP_AUTH
        });
    });
});

$('.js-common-popup-back', $forgotEmailPopup).on('click', (e) => {console.log(e.currentTarget);
    const $form = $(e.currentTarget).closest('.js-common-popup').find('.js-form');

    $forgotEmailPopup.trigger('popup:close');

    if ($form.hasClass('_form-message')) {
        requestAnimationFrame(() => {
            $choicePopup.trigger('popup:open', {
                name: POPUP_CHOICE
            });
        });
    } else {
        requestAnimationFrame(() => {
            $authPopup.trigger('popup:open', {
                name: POPUP_AUTH
            });
        });
    }
});

$('.js-common-popup-back-to-choice').on('click', () => {
    $forgotEmailPopup.trigger('popup:close');

    requestAnimationFrame(() => {
        $choicePopup.trigger('popup:open', {
            name: POPUP_CHOICE
        });
    });
});

$quickAuthPhoneForm.add($quickAuthEmailForm).on('form:success', () => {
    $authPopup.trigger('popup:close');
});

$registrationForm.on('form:error', () => {
    requestAnimationFrame(() => {
        $formPopup.trigger('popup:open', {
            name: POPUP_FORM,
            noResetForm: true
        });
    });
});

$quickRegPhone.on('change', ()=> {
    $registrationForm.removeClass('phone-is-accept');
});

$smsResend.on('click', (e)=> {
    if (smsResendTimer) return;
    if (e.type == 'click') quickRegistrationSmsRrequest();
    $smsResend.attr('disabled', true);
    smsResendTimer = setTimeout(function () {
        $smsResend.attr('disabled', false);
        clearTimeout(smsResendTimer);
        smsResendTimer = null;
    }, smsResendDuration * 1000);
});

export function quickRegAfterCheckingPhone() {
    $confirmPhonePopup.trigger('popup:close');
    $registrationForm.find('.js-submit').trigger('click');
}

export function quickRegistrationSmsRrequest() {
    $formPopup.trigger('popup:close');
    $confirmPhonePopup.trigger('popup:open', {name: POPUP_CONFIRM_PHONE});

    $('[data-quick-reg-sms-confirmed-form]').removeClass('phone-is-accept');
    $smsRequest.find('input[type="text"]').attr('disabled', false);
    $smsRequest.find('.ajax-error').html('');

    $.ajax({
        url: $smsRequest.attr('action'),
        method: $smsRequest.attr('method') || 'GET',
        data: {
            //phone: phone,
            phone: $('.js-sms-phone-field', $formPopup).val(),
            "smart-token": App.currentRecaptcha
        },
        success: (response) => {
            if (response.success) {
                $smsSend.find('.ajax-error').html('');
                //$('[data-sms-confirmed-form]').find('.js-submit').trigger('click');
            } else {
                $smsRequest.find('input[type="text"]').attr('disabled', true);
                $smsRequest.find('.ajax-error').html(response.message);
                console.log(response.message || 'Ошибка от сервера');
                $smsSend.find('.ajax-error').html(response.message);
            }
        },
        error: () => {
            console.log('Ошибка получения данных');
        }
    });
}
